import React from "react";
import PlayingCards from "../../../../assets/images/OCH/playing-card.png";
import FrontPlayingCard from "../../../../assets/images/OCH/front-playing-card.png";
import SmallCard from "../../../../assets/images/OCH/small-card.png";
import card from "../../../../assets/images/card";
import spade from "../../../../assets/images/card/Sspade.png"
import club from "../../../../assets/images/card/Sclub.png"
import diamond from "../../../../assets/images/card/Sdiamond.png"
import heart from "../../../../assets/images/card/Sheart.png"
import _ from 'lodash';

const CardsViewResult = (props) => {
  const roomData = _.get(props, "roomData");
  const crazy_suit = _.get(roomData, "game_state.crazy_suit");
  const status = _.get(roomData, "game_state.status");
  const currentCard = _.get(roomData, "game_state.current_card");
  const num = _.get(currentCard, "number");
  let imgSrc = ''
  if (currentCard !== undefined) {
    imgSrc = card[`${currentCard?.suit}`][num];
  }
  return (
    <>
      {/* {card.crazy_suit !== undefined ?
    <div className="playingCardsSingleWrap">
    <div className="playingCardsSingleWrapper">
      <div className="backdrop"></div>
      <div className="card-small-wrapper">
        <img src={card.crazy_suit[`${crazy_suit}`]} />
      </div>
    </div>
  </div>
    : */}
      <div className="playingCardsSingleWrap">
        <div className="playingCardsSingleWrapper">
          <img src={currentCard.url} className="front-single-image" />
        </div>
      </div>
    </>
  );
};

export default CardsViewResult